import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  successIcon: {
    '&&': {
      fill: theme.palette.success.main,
      width: 24,
      height: 24,
    },
  },
  failureIcon: {
    '&&': {
      fill: theme.palette.error.main,

      width: 24,
      height: 24,
    },
  },
  modalWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xl,

    padding: SPACES.xxl,

    minHeight: 340,

    maxHeight: 'calc(100vh - 180px)',
    [theme.breakpoints.down('tablet')]: {
      maxWidth: 'calc(100vw - 40px)',
    },
    [theme.breakpoints.up('tablet')]: {
      maxWidth: '600px',
    },
  },
  title: {
    '&&': {
      textAlign: 'center',
      fontSize: FONTS.SIZES.xl,
      fontWeight: FONTS.WEIGHTS.bold,
      color: theme.palette.custom.darkBlue2,
    },
  },
  responseWrapper: {
    backgroundColor: theme.palette.custom.grey,
    padding: SPACES.s,

    overflowY: 'auto',
    wordBreak: 'break-all',
    wordWrap: 'break-word',
  },

  cardsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.l,
  },
  cardWrapper: {
    '&&': {
      backgroundColor: theme.palette.custom.white,
      border: `1px solid ${theme.palette.custom.grey}`,
      borderRadius: '10px',
      boxShadow: 'none',

      width: 'calc(100vw - 40px)',
    },
  },
  cardContent: {
    '&&': {
      padding: SPACES.m,

      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      columnGap: 5,

      color: theme.palette.custom.darkBlue2,

      '&:last-child': {
        paddingBottom: SPACES.m,
      },
    },
  },
  cardLeftWrapper: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 65,
  },
  cardRightWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  cardName: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.m,
      lineHeight: 1.35,
      color: 'inherit',
    },
  },

  linkIcon: {
    '&&': {
      width: 20,
      heigh: 20,
      color: theme.palette.custom.grey2,
    },
  },
}))
